<template>
  <div class="common_bg forrecord">
    <div class="law">
      <div class="title">
        <span>备案公示</span>
      </div>
      <div class="content">
        <iframe src="https://agreement.limiketang.com/forrecord/index.html" frameborder="0"></iframe>
      </div>
    </div>
    <Back @goBack="goBack"/>
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
export default {
  components: {
    Back
  },
  methods: {
    goBack() {
      this.$router.push("/userinfo");
    }
  }
};
</script>
<style lang="less" scoped>
@bg-color: #0089ce;
.contnet-common {
  width: 100%;
  height: 100%;
  padding-bottom: 60px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.forrecord {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: @bg-color;
    font-size: 26px;
    color: #fff;
    position: relative;
    margin-bottom: 15px;
  }
  .law {
    .contnet-common;
  }
  .law .content {
    background: #fff;
    height: 100%;
    margin: 0 auto;
    width:1024px;
    overflow: hidden;
    border-radius: 20px;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/explain/forrecord.vue